import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";

export const ctfAuthPageMessages: Record<AppLocale, MessageTree> = {
  "zh-CN": {
    ctf: {
      pages: {
        login: {
          summary: "通过 AIRange SSO 登录后进入 CTF 教员工作台。",
          bootstrapTitle: "正在校验登录态",
          bootstrapDescription: "将自动识别当前 SSO 会话并建立 CTF 本地会话。",
          noSessionTitle: "还没有可用的登录态",
          noSessionDescription: "请先跳转到统一登录入口，完成 AIRange SSO 登录。",
          noAccessTitle: "当前账号没有 CTF 后台权限",
          noAccessDescription: "需要具备 ctf_teacher、ctf_manager 或 ctf_admin 角色后才能进入后台。",
          enterAction: "进入后台",
          switchIdentityAction: "切换账号登录",
          redetectAction: "重新识别权限"
        },
        oidcCallback: {
          completing: "正在完成 OIDC 登录...",
          missingCodeOrState: "OIDC 回调缺少 code/state 参数",
          bootstrapSessionFailed: "CTF 后台本地会话初始化失败",
          callbackFailed: "OIDC 回调失败"
        },
        notFound: {
          title: "页面不存在",
          description: "当前地址没有对应的 CTF 后台页面。",
          backHome: "回到首页"
        }
      }
    }
  },
  en: {
    ctf: {
      pages: {
        login: {
          summary: "Sign in with AIRange SSO to enter the CTF teacher workspace.",
          bootstrapTitle: "Checking session",
          bootstrapDescription: "The app is detecting the current SSO session and bootstrapping a local CTF session.",
          noSessionTitle: "No active session",
          noSessionDescription: "Continue to the unified login entry and complete AIRange SSO.",
          noAccessTitle: "No CTF admin access",
          noAccessDescription: "The account needs ctf_teacher, ctf_manager, or ctf_admin role.",
          enterAction: "Enter",
          switchIdentityAction: "Switch account",
          redetectAction: "Check again"
        },
        oidcCallback: {
          completing: "Completing OIDC login...",
          missingCodeOrState: "OIDC callback is missing code/state",
          bootstrapSessionFailed: "Failed to bootstrap the CTF admin local session",
          callbackFailed: "OIDC callback failed"
        },
        notFound: {
          title: "Page not found",
          description: "No CTF admin page matches this URL.",
          backHome: "Back home"
        }
      }
    }
  },
  ja: {
    ctf: {
      pages: {
        login: {
          summary: "AIRange SSO でログインして CTF 教員ワークスペースに入ります。",
          bootstrapTitle: "セッション確認中",
          bootstrapDescription: "現在の SSO セッションを検出し、CTF ローカルセッションを作成しています。",
          noSessionTitle: "利用可能なログイン状態がありません",
          noSessionDescription: "統一ログインに移動して AIRange SSO を完了してください。",
          noAccessTitle: "CTF 管理権限がありません",
          noAccessDescription: "ctf_teacher、ctf_manager、または ctf_admin ロールが必要です。",
          enterAction: "入る",
          switchIdentityAction: "アカウントを切り替える",
          redetectAction: "再確認"
        },
        oidcCallback: {
          completing: "OIDC ログインを完了しています...",
          missingCodeOrState: "OIDC callback に code/state がありません",
          bootstrapSessionFailed: "CTF 管理ローカルセッションの初期化に失敗しました",
          callbackFailed: "OIDC callback に失敗しました"
        },
        notFound: {
          title: "ページが見つかりません",
          description: "この URL に対応する CTF 管理ページはありません。",
          backHome: "ホームへ戻る"
        }
      }
    }
  }
};
